import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import { Remove as RemoveIcon } from "@mui/icons-material";
import { Column, GridApi, IRowNode } from "ag-grid-community";
import { useEffect, useState } from "react";
import { Torch } from "../../../models/torches.models";
import { numericCellRendererStyles } from "./numericCellRendererStyles";

export const NumericCellRenderer = ({
  torch,
  field,
  onCellValueChanged,
}: {
  torch: Torch;
  node: IRowNode;
  column: Column;
  api: GridApi;
  field: "TotalCuts" | "Undefined" | "Scrapped" | "Billets";
  onCellValueChanged: (
    torch: Torch,
    action: "increment" | "decrement",
    field: keyof Torch,
    newValue: number,
  ) => void;
}) => {
  const theme = useTheme();
  const styles = numericCellRendererStyles(theme);

  if (!torch?.HotLength || torch.HotLength === 0) return null;
  const value = torch[field] || 0;

  const increment = () => {
    onCellValueChanged(torch, "increment", field, value);
  };

  const decrement = () => {
    onCellValueChanged(torch, "decrement", field, value);
  };

  return (
    <Box sx={styles.numericCellContainer}>
      <IconButton
        onClick={decrement}
        size="small"
        sx={{ padding: 0, mr: theme.spacing(1) }}
        disabled={value === 0 || (field === "TotalCuts" && torch.Billets === 0)}
      >
        <RemoveIcon fontSize="small" sx={styles.decrementIcon} />
      </IconButton>
      <Typography variant="caption" sx={styles.valueTypography}>
        {value}
      </Typography>
      <IconButton
        onClick={increment}
        size="small"
        sx={{ padding: 0, ml: theme.spacing(1) }}
        disabled={
          (field === "Scrapped" || field === "Undefined") && torch.Billets === 0
        }
      >
        <AddIcon fontSize="small" sx={styles.incrementIcon} />
      </IconButton>
    </Box>
  );
};
